import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { usePermissions } from "@/hooks/usePermissions";

const Spinner = () => (
  <div className="flex h-screen items-center justify-center bg-background">
    <div className="flex items-center gap-3 text-muted-foreground">
      <span className="h-3 w-3 animate-ping rounded-full bg-primary" />
      <span className="font-display text-sm tracking-wider uppercase">Carregando</span>
    </div>
  </div>
);

export default function ProtectedRoute({ children, roles, module: moduleKey, action = "view" }) {
  const { user, loading } = useAuth();
  const { can, loading: permLoading } = usePermissions();
  if (loading || user === null) return <Spinner />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && user.role !== "master" && !roles.includes(user.role)) {
    return <Navigate to="/dashboard" replace />;
  }
  if (moduleKey && !permLoading && !can(moduleKey, action)) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
}
